/**
 * useSchedulePresence.ts
 * "Who's viewing" presence for the schedule views (UX overhaul, M8).
 * Heartbeats every ~20s and polls the active viewers for the current view.
 * Best-effort and cheap (in-memory backend); pauses when the tab is hidden.
 */

import { useEffect, useState } from 'react';
import { postPresenceHeartbeat, fetchPresence, type PresenceViewer, type ScheduleView } from '../services/scheduleEmployeeBars';

export function useSchedulePresence(view: ScheduleView): PresenceViewer[] {
  const [viewers, setViewers] = useState<PresenceViewer[]>([]);

  useEffect(() => {
    let alive = true;
    const beat = async () => {
      if (document.hidden) return;
      try {
        await postPresenceHeartbeat(view);
        const v = await fetchPresence(view);
        if (alive) setViewers(v);
      } catch { /* presence is best-effort */ }
    };
    void beat();
    const id = window.setInterval(beat, 20_000);
    return () => { alive = false; window.clearInterval(id); };
  }, [view]);

  return viewers;
}
